import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import Navbar from './components/Navbar/Navbar';
import Footer from './components/Footer/Footer';
import Home from './pages/Home';
import Sobre from './pages/Sobre';
import Blog from './pages/Blog';
import BlogArticle from './pages/BlogArticle';
import Contato from './pages/Contato';
import Diagnostico from './pages/Diagnostico';
import Casos from './pages/Casos';
import CasoDetail from './pages/CasoDetail';
import PortalCliente from './pages/PortalCliente';
import PortalCadastro from './pages/PortalCadastro';
import PortalEsqueciSenha from './pages/PortalEsqueciSenha';
import PortalResetarSenha from './pages/PortalResetarSenha';
import PortalSistema from './pages/PortalSistema';

function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) {
      const el = document.querySelector(hash);
      if (el) {
        setTimeout(() => el.scrollIntoView({ behavior: 'smooth' }), 100);
        return;
      }
    }
    window.scrollTo(0, 0);
  }, [pathname, hash]);

  return null;
}

function AppLayout() {
  const { pathname } = useLocation();
  const isSistemaIndependente = pathname.startsWith('/portal/sistemas/captura-nfe-sefaz');

  return (
    <>
      {!isSistemaIndependente && <Navbar />}
      <main>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/sobre" element={<Sobre />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/:slug" element={<BlogArticle />} />
          <Route path="/contato" element={<Contato />} />
          <Route path="/diagnostico" element={<Diagnostico />} />
          <Route path="/casos" element={<Casos />} />
          <Route path="/casos/:slug" element={<CasoDetail />} />
          <Route path="/portal" element={<PortalCliente />} />
          <Route path="/portal/cadastro" element={<PortalCadastro />} />
          <Route path="/portal/esqueci-senha" element={<PortalEsqueciSenha />} />
          <Route path="/portal/resetar-senha" element={<PortalResetarSenha />} />
          <Route path="/portal/sistemas/:id" element={<PortalSistema />} />
        </Routes>
      </main>
      {!isSistemaIndependente && <Footer />}
    </>
  );
}

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <AppLayout />
    </BrowserRouter>
  );
}

export default App;
